<template lang="pug">
v-card.mb-3
  v-card-title.grey.lighten-4
    .title Toolbox
  v-card-text
    v-btn.block-left(block color="primary" outline to="/telefonliste")
      v-icon(left) phone
      | Telefonliste
    v-btn.block-left(block color="primary" outline to="/projektliste")
      v-icon(left) list
      | Projektliste
    v-btn.block-left(block color="primary" outline to="/stellenmarkt")
      v-icon(left) assignment_ind
      | Stellenmarkt
    v-btn.block-left(block color="primary" outline href="https://hvdbox.de/cloud/index.php/s/635TVUWO3ykSxrj")
      v-icon(left) inbox
      | HVD-Box

</template>

<style lang="stylus" scoped>
.block-left >>> .v-btn__content
  justify-content left
</style>

<script>
export default {
  props: ['extra']
}
</script>
